var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop, ModelSync } from 'vue-property-decorator';
import { BRow, BCol } from 'bootstrap-vue';
import MouldingResult from 'components/picture-frames/Tabs/MouldingOptions/MouldingResult.vue';
let MouldingResults = class MouldingResults extends Vue {
    mouldingSelected;
    mouldings;
    loading;
    nonFramePrice;
    onSelect(moulding) {
        if (this.mouldingSelected && moulding.sku === this.mouldingSelected.sku) {
            // Deselect the moulding
            this.$emit('change', null);
        }
        else {
            this.$emit('change', moulding);
        }
    }
};
__decorate([
    ModelSync('moulding', 'change', { type: Object })
], MouldingResults.prototype, "mouldingSelected", void 0);
__decorate([
    Prop(Array)
], MouldingResults.prototype, "mouldings", void 0);
__decorate([
    Prop(Boolean)
], MouldingResults.prototype, "loading", void 0);
__decorate([
    Prop(Number)
], MouldingResults.prototype, "nonFramePrice", void 0);
MouldingResults = __decorate([
    Component({
        components: {
            BRow, BCol,
            MouldingResult
        }
    })
], MouldingResults);
export default MouldingResults;
